import React, { Component } from 'react';
import UserForm from './UserForm';

export class CreateUser extends Component {
    static displayName = CreateUser.name;

    render() {
        return (
            <UserForm userId='0' formType='Create' />  
        );
    }
}